import { api } from '../../../lib/api'

export const UPDATE_PRODUCT_REQUEST = 'UPDATE_PRODUCT_REQUEST'
export const UPDATE_PRODUCT_SUCCESS = 'UPDATE_PRODUCT_SUCCESS'
export const UPDATE_PRODUCT_FAILED = 'UPDATE_PRODUCT_FAILED'

export const updateProductFields = function (productData, productId, isFormData = false) {
  return function (dispatch) {
    dispatch({
      type: UPDATE_PRODUCT_REQUEST
    })
    
    return api.updateProductFields(productData, productId, isFormData).then(updateProductResponse => {
      dispatch({
        type: UPDATE_PRODUCT_SUCCESS,
        payload: updateProductResponse
      })
      // if (onComplete) onComplete()
    }).catch(error => {
      dispatch({
        type: UPDATE_PRODUCT_FAILED,
        error
      })
      // if (onComplete) onComplete()
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/product/update-product.js